import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { firstLetters } from 'utils/strings';
import { Link } from 'react-router-dom';
import { TIMELINE_TYPES } from 'utils/constants/timeline';

export default function ItemDefault(props) {
  const {
    avatarImage,
    name,
    period,
    avatarUrl,
    clientId,
    eventId,
    eventType,
    title,
    message
  } = props;

  var eventUrl;
  switch (eventType) {
    case TIMELINE_TYPES.TRAINER_ASSIGN_NUTRITION:
      eventUrl = `/nutrition/${eventId}`;
      break;
    case TIMELINE_TYPES.TRAINER_ASSIGN_WORKOUT:
      eventUrl = `/workouts/${eventId}`;
      break;
    case TIMELINE_TYPES.TRAINER_ADD_NOTE:
      eventUrl = `/clients/${clientId}/notes/${eventId}`;
      break;
    case TIMELINE_TYPES.TRAINER_ADD_ASSESSMENT:
      eventUrl = `/clients/${clientId}/assessments/${eventId}`;
      break;
    case TIMELINE_TYPES.CLIENT_KICKSTART_QUESTIONNAIRE:
      eventUrl = `/clients/${clientId}/questionnaire`;
      break;
    default:
      eventUrl = null;
  }

  return (
    <div className="timeline-item">
      <Avatar
        src={avatarImage}
        width="32"
        height="32"
        name={name}
        text={`${period} ago`}
        firstLetters={firstLetters(name)}
        url={avatarUrl}
      />
      <div className="activity-info">
        {eventUrl ? <Link to={eventUrl}>{title}</Link> : <h4>{title}</h4>}
        <p className="timeline-content">{message}</p>
      </div>
    </div>
  );
}
